import { render, staticRenderFns } from "./ChannelTwoNews.vue?vue&type=template&id=3e26ce91&scoped=true"
import script from "./ChannelTwoNews.vue?vue&type=script&lang=js"
export * from "./ChannelTwoNews.vue?vue&type=script&lang=js"
import style0 from "./ChannelTwoNews.vue?vue&type=style&index=0&id=3e26ce91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e26ce91",
  null
  
)

export default component.exports